/*
 * - Stores paths for the lookup service endpoints
 */

const serviceRoot = 'https://gis.blm.gov/natlplss/rest/services/Cadastral/BLM_Natl_PLSS_CadNSDI/';
export const PlssEndpoints = {
  getPlss: () => `${serviceRoot}MapServer/3/query?`,
};
